import React from 'react';
import { ArrowRight, Fire } from '@phosphor-icons/react';
import { WaveSeparator } from './WaveSeparator';
import { SHOP_VIDEO_ID_DEFAULT } from './shopUtils';

export const Hero = ({ id, colors, setView }) => {
  const heroImage = id.hero_image_url || 'https://images.pexels.com/photos/32593246/pexels-photo-32593246.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940';
  const heroL1 = id.hero_line1 || 'Une offre gourmande';
  const heroL2 = id.hero_line2 || "Et d'exception !";
  const heroSub = id.hero_subtitle || "Viandes d'exception, sélectionnées avec passion depuis le coeur de la Provence";
  const heroCta = id.hero_cta_text || 'Découvrir la boutique';

  return (
    <section className="relative overflow-hidden -mt-[50px] md:-mt-[50px]" style={{ height: 'clamp(380px, 60vh, 750px)' }} data-testid="hero-section">
      <div className="absolute inset-0 z-0 overflow-hidden">
        <img
          src={heroImage}
          className="absolute inset-0 w-full h-full object-cover"
          alt="MRG Optique & Audition"
          loading="eager"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70 z-[1]" />
      <div className="relative z-[2] flex flex-col items-center justify-center h-full px-4">
        <h1 className="text-white text-center leading-tight" style={{ transform: 'rotate(-3deg)', transformOrigin: 'center center' }}>
          <span className="block text-[32px] md:text-[56px] tracking-[-0.02em] mb-[-8px] md:mb-[-16px] opacity-0 animate-fadeInUp" style={{ fontFamily: "'Dancing Script', cursive", animationDelay: '0.3s', animationFillMode: 'forwards' }}>
            {heroL1}
          </span>
          <span className="block text-[56px] md:text-[130px] tracking-[-0.03em] leading-[0.95] opacity-0 animate-fadeInUp"
            style={{ fontFamily: "'Dancing Script', cursive", animationDelay: '0.8s', animationFillMode: 'forwards' }}>
            {heroL2}
          </span>
        </h1>
        <p className="text-white/70 text-[16px] md:text-[18px] mt-2 opacity-0 animate-fadeInUp max-w-[500px] text-center" style={{ fontFamily: "'Poppins', sans-serif", animationDelay: '1.2s', animationFillMode: 'forwards' }}>
          {heroSub}
        </p>
        <button onClick={() => setView('shop')}
          className="mt-8 px-10 py-4 rounded-full text-white text-[15px] font-bold tracking-wide transition-all hover:scale-105 hover:shadow-2xl opacity-0 animate-fadeInUp"
          style={{ backgroundColor: colors.primary, animationDelay: '1.6s', animationFillMode: 'forwards' }}
          data-testid="hero-cta">
          {heroCta} <ArrowRight size={18} weight="bold" className="inline ml-2" />
        </button>
      </div>
      <WaveSeparator color="#ffffff" className="absolute bottom-0 left-0 right-0 z-[3]" />
    </section>
  );
};

export const ShopHero = ({ id, colors, categories, selectedCategory, goCategory }) => {
  const activeCat = categories.find(c => c.id === selectedCategory);
  const heroTitle = activeCat ? activeCat.name : 'Notre Boutique';
  const heroSubtitle = activeCat ? `Découvrez notre sélection ${activeCat.name}` : (id.hero_subtitle || 'Découvrez toute notre sélection de lunettes et solutions auditives');
  const shopImage = id.shop_image_url || 'https://images.unsplash.com/photo-1511499767150-a48a237f0083?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600';
  const braseroCat = categories.find(c => c.slug && c.slug.toLowerCase().includes('brasero'));

  return (
    <section className="relative overflow-hidden -mt-[50px] md:-mt-[50px]" style={{ height: 'clamp(320px, 50vh, 750px)', paddingTop: 50 }} data-testid="shop-hero">
      <div className="absolute inset-0 z-0 overflow-hidden">
        <img
          src={shopImage}
          className="absolute inset-0 w-full h-full object-cover"
          alt="Notre boutique"
          loading="eager"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/65 z-[1]" />
      <div className="relative z-[2] flex flex-col items-center justify-center h-full px-4 text-center">
        <h1 className="text-white text-[32px] md:text-[56px] font-semibold leading-tight mb-3" style={{ fontFamily: "'Poppins', sans-serif" }}>
          {heroTitle}
        </h1>
        <p className="text-white/60 text-[15px] md:text-[18px] max-w-[550px] mb-8" style={{ fontFamily: "'Poppins', sans-serif" }}>{heroSubtitle}</p>
        {braseroCat && !selectedCategory && (
          <button onClick={() => goCategory(braseroCat.id)}
            className="inline-flex items-center gap-2.5 px-8 py-4 rounded-full text-white text-[15px] font-bold transition-all hover:scale-105 hover:shadow-2xl"
            style={{ backgroundColor: colors.primary }}
            data-testid="discover-brasero-btn">
            <Fire size={20} weight="fill" /> Découvrir nos BRASERO <ArrowRight size={18} weight="bold" />
          </button>
        )}
      </div>
      <WaveSeparator color="#ffffff" className="absolute bottom-0 left-0 right-0 z-[3]" />
    </section>
  );
};
